export function findAttributionToken(productId: string) {
  const tokens = JSON.parse(localStorage.getItem('attributionTokens') || '{}');

  return tokens[productId];
}

export function setAttributionToken(
  productId: string,
  attributionToken: string
) {
  const tokens = JSON.parse(localStorage.getItem('attributionTokens') || '{}');

  localStorage.setItem(
    'attributionTokens',
    JSON.stringify({
      ...tokens,
      [productId]: attributionToken,
    })
  );
}
